<template>
  <v-app id="login">
    <v-snackbar v-model="snackbar" color="error">
      {{ snackbarContent }}
      <v-btn text @click="snackbar = false" timeout="3000">Close</v-btn>
    </v-snackbar>

    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" class="text-center mb-5">
            <img src="../assets/logo.png" width="200px" />
          </v-col>
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title>Tableau de bord du formateur</v-toolbar-title>
                <v-spacer />
              </v-toolbar>
              <v-card-text>
                <v-form v-model="formValid">
                  <v-text-field
                    label="Email"
                    prepend-icon="mdi-account"
                    type="text"
                    v-model="email"
                    :rules="emailRules"
                  />

                  <v-text-field
                    label="Mot de passe"
                    prepend-icon="mdi-lock"
                    type="Password"
                    :rules="[v => !!v || 'Entrer un mot de passe']"
                    v-model="password"
                  />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  width="100%"
                  color="secondary"
                  @click="login"
                  :loading="loginLoader"
                  :disabled="!formValid"
                >{{$t('login.loginBtn')}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      password: "",
      emailRules: [
        v => !!v || "L'email est requis",
        v => /.+@.+\..+/.test(v) || "L'email doit être valide"
      ],

      formValid: false,
      snackbar: false,
      snackbarContent: "",

      loginLoader: false
    };
  },
  methods: {
    //   -------------------------------------------- Login Function ------------------------------------------------------
    login: function() {
      this.loginLoader = true;
      this.$http
        .post("/trainer/authenticate", {
          username: this.email,
          password: this.password
        })
        .then(res => {
          let user = res.data.user;
          let token = res.data.token;
          this.$cookies.set("trainer_user_token", token, 60 * 60 * 1);

          this.$store.commit("saveUser", { user });

          window.location.href = "/";
        })
        .catch(e => {
          console.log(e.response);
          var err = e.response.status;
          if (err == 401) {
            this.snackbar = true;
            this.snackbarContent = "L'email / mot de passe est incorrect.";
            this.loginLoader = false;
          } else if (this.email == "" || this.password == "") {
            this.snackbar = true;
            this.snackbarContent = "Entrez votre e-mail et votre mot de passe";
            this.loginLoader = false;
          } else {
            this.snackbar = true;
            this.snackbarContent =
              "Erreur inconnue. Contacter l'administrateur";
            this.loginLoader = false;
          }
        });
    }
    // -------------------------------------------- Login function end -----------------------------------------------------
  }
};
</script>